import type { FunctionComponent, SVGProps } from "react";
import MoreIcon from "src/images/Icons/newIcons/exam/options/more.svg";

import Menu from "../../Default/LekUI/Menu";

interface ActionItem {
	Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
	action: () => void;
	text: string;
	disabled?: boolean;
}

interface ActionsProps {
	items: ActionItem[];
	className?: string;
}

export const Actions = ({ items }: ActionsProps) => {
	return (
		<Menu
			closeAfterClick
			buttonClassName="menu-icon-button square-28"
			icon={<MoreIcon className="icon-normal" />}
			items={items.map(({ Icon, action, text, disabled }) => {
				return {
					Icon: <Icon className="icon-small" />,
					title: text,
					onClick: action,
					disabled,
				};
			})}
		/>
	);
};
